// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file giftcard.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { GiftcardTransaction } from "./giftcard_transaction_pb";
import { file_giftcard_transaction } from "./giftcard_transaction_pb";
import type { Contact } from "./contact_pb";
import { file_contact } from "./contact_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file giftcard.proto.
 */
export const file_giftcard: GenFile = /*@__PURE__*/
  fileDesc("Cg5naWZ0Y2FyZC5wcm90bxILZ3JwYy5hcGkudjEiXwoRR2lmdGNhcmRSZWNpcGllbnQSGAoQZ2lmdGNhcmRfbWVzc2FnZRgBIAEoCRINCgVlbWFpbBgCIAEoCRIMCgRuYW1lGAMgASgJEhMKC2R0X2RlbGl2ZXJ5GAQgASgDIrcECghHaWZ0Y2FyZBIKCgJpZBgBIAEoAxINCgV0aXRsZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRIcChRiYWNrZ3JvdW5kX2ltYWdlX3VybBgEIAEoCRISCgpzZXJ2aWNlX2lkGAUgASgDEg4KBmxvY2FsZRgGIAEoCRIPCgdiYWxhbmNlGAcgASgFEhAKCGN1cnJlbmN5GAggASgJEg4KBnN0YXR1cxgJIAEoCRIMCgRjb2RlGAogASgJEg0KBWNvbG9yGAsgASgJEhEKCWR0X2NyZWF0ZRgMIAEoAxIRCglkdF91cGRhdGUYDSABKAMSEQoJZHRfZXhwaXJ5GA4gASgDEg0KBXByaWNlGA8gASgFEhEKCXNob3dfbG9nbxgQIAEoCBITCgtmb290ZXJfdGV4dBgRIAEoCRIxCglyZWNpcGllbnQYEiABKAsyHi5ncnBjLmFwaS52MS5HaWZ0Y2FyZFJlY2lwaWVudBIlCgdjb250YWN0GBMgASgLMhQuZ3JwYy5hcGkudjEuQ29udGFjdBI2Cgx0cmFuc2FjdGlvbnMYFCADKAsyIC5ncnBjLmFwaS52MS5HaWZ0Y2FyZFRyYW5zYWN0aW9uEhIKCmlzX2V4cGlyZWQYFSABKAgSFQoNZHRfZXhwaXJ5X21pbBgWIAEoBRIcChRpc3N1ZWRfYnlfYWNjb3VudF9pZBgXIAEoAxIeChZpc3N1ZWRfYnlfYWNjb3VudF9uYW1lGBggASgJQgZaBC47cGJiBnByb3RvMw", [file_giftcard_transaction, file_contact]);

/**
 * GiftcardRecipient
 *
 * @generated from message grpc.api.v1.GiftcardRecipient
 */
export type GiftcardRecipient = Message<"grpc.api.v1.GiftcardRecipient"> & {
  /**
   * @generated from field: string giftcard_message = 1;
   */
  giftcardMessage: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: int64 dt_delivery = 4;
   */
  dtDelivery: bigint;
};

/**
 * Describes the message grpc.api.v1.GiftcardRecipient.
 * Use `create(GiftcardRecipientSchema)` to create a new message.
 */
export const GiftcardRecipientSchema: GenMessage<GiftcardRecipient> = /*@__PURE__*/
  messageDesc(file_giftcard, 0);

/**
 * Giftcard
 *
 * @generated from message grpc.api.v1.Giftcard
 */
export type Giftcard = Message<"grpc.api.v1.Giftcard"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string background_image_url = 4;
   */
  backgroundImageUrl: string;

  /**
   * @generated from field: int64 service_id = 5;
   */
  serviceId: bigint;

  /**
   * @generated from field: string locale = 6;
   */
  locale: string;

  /**
   * @generated from field: int32 balance = 7;
   */
  balance: number;

  /**
   * @generated from field: string currency = 8;
   */
  currency: string;

  /**
   * @generated from field: string status = 9;
   */
  status: string;

  /**
   * @generated from field: string code = 10;
   */
  code: string;

  /**
   * @generated from field: string color = 11;
   */
  color: string;

  /**
   * @generated from field: int64 dt_create = 12;
   */
  dtCreate: bigint;

  /**
   * @generated from field: int64 dt_update = 13;
   */
  dtUpdate: bigint;

  /**
   * @generated from field: int64 dt_expiry = 14;
   */
  dtExpiry: bigint;

  /**
   * @generated from field: int32 price = 15;
   */
  price: number;

  /**
   * @generated from field: bool show_logo = 16;
   */
  showLogo: boolean;

  /**
   * @generated from field: string footer_text = 17;
   */
  footerText: string;

  /**
   * @generated from field: grpc.api.v1.GiftcardRecipient recipient = 18;
   */
  recipient?: GiftcardRecipient | undefined;

  /**
   * @generated from field: grpc.api.v1.Contact contact = 19;
   */
  contact?: Contact | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.GiftcardTransaction transactions = 20;
   */
  transactions: GiftcardTransaction[];

  /**
   * @generated from field: bool is_expired = 21;
   */
  isExpired: boolean;

  /**
   * @generated from field: int32 dt_expiry_mil = 22;
   */
  dtExpiryMil: number;

  /**
   * @generated from field: int64 issued_by_account_id = 23;
   */
  issuedByAccountId: bigint;

  /**
   * @generated from field: string issued_by_account_name = 24;
   */
  issuedByAccountName: string;
};

/**
 * Describes the message grpc.api.v1.Giftcard.
 * Use `create(GiftcardSchema)` to create a new message.
 */
export const GiftcardSchema: GenMessage<Giftcard> = /*@__PURE__*/
  messageDesc(file_giftcard, 1);

